export class TitleList {
  title!: string;
  type!: string;
  value!: string | string[];
}
